import { ContactThanksPage } from "@components/pages/ContactThanksPage"
import { SiteShell } from "@components/SiteShell"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"

export const Route = createFileRoute("/$locale/contact/thanks")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "contact", path: `/${locale}/contact/thanks` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as "en" | "ja"
  return (
    <SiteShell
      locale={locale}
      page="thanks"
    >
      <ContactThanksPage locale={locale} />
    </SiteShell>
  )
}
